module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av583-b6c69dfb7007100334b2d053e31b885f.jpg";